import { ReactNode } from "react";
import { IOverviewPeriod } from "../../interfaces-and-types";
import moment from "moment";
import { appConfig } from "../../configs";

export interface IOverviewPeriodDisplay extends IOverviewPeriod {
  title?: string | ReactNode;
}

export const OverviewPeriodDisplay = (props: IOverviewPeriodDisplay) => {
  return (
    <div
      className="overview-period--display mr-5"
      // onClick={() => {}}
    >
      <span className="text-success font-ctm--bold">
        {" "}
        {moment(props.start_date).format(appConfig.dateFormat1)}{" "}
      </span>
      <span className="font-ctm--bold">—</span>
      <span className="text-danger font-ctm--bold">
        {" "}
        {moment(props.end_date).format(appConfig.dateFormat1)}{" "}
      </span>
    </div>
  );
};
